import { styled } from '@mui/material/styles'

export const Container = styled('div')(({ theme }) => {
  return {
    padding: '0 40px 20px',
    flex: 1,
    marginTop: '16px',
    marginBottom: '16px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'scroll',
    [theme.breakpoints.down('tablet')]: {
      padding: '0 8px',
    },
  }
})
